import { createCrudThunks } from '../../store/createCrudThunks';
import { emailApi, type EmailListParams } from './emailApi';
import type { Email, EmailCreatePayload, EmailUpdatePayload } from './emailTypes';

const thunks = createCrudThunks<Email, EmailCreatePayload, EmailUpdatePayload, EmailListParams>(
  'emails',
  emailApi,
);

export const emailThunks = thunks;
export const {
  fetchAll: fetchEmails,
  fetchOne: fetchEmail,
  create: createEmail,
  update: updateEmail,
  remove: deleteEmail,
} = thunks;
